import React from 'react';

import { cn } from '@/lib/utils';

interface ACCreationStepsProps {
  activeStep: number;
  className?: string;
  showMembersStep?: boolean;
}

const allSteps = [
  { number: 1, title: 'Accounting Center' },
  { number: 2, title: 'Members' }
];

const ACCreationSteps: React.FC<ACCreationStepsProps> = ({ activeStep, className, showMembersStep = true }) => {
  const steps = showMembersStep ? allSteps : allSteps.slice(0, 1);

  return (
    <div className={cn('hidden md:flex items-center gap-2', className)}>
      {steps.map((step, index) => {
        const isActive = activeStep === step.number;
        const isCompleted = activeStep > step.number;
        const isLast = index === steps.length - 1;

        return (
          <React.Fragment key={step.number}>
            <div className="flex items-center gap-2">
              <span
                className={cn(
                  'size-6 text-sm flex items-center justify-center rounded-full',
                  isActive || isCompleted
                    ? 'bg-primary text-white'
                    : 'bg-transparent border border-lightGray text-secondary'
                )}
              >
                {step.number}
              </span>
              <p className={cn('text-sm whitespace-nowrap', !isActive && !isCompleted && 'text-secondary')}>
                {step.title}
              </p>
            </div>
            {!isLast && <div className="h-[1px] w-10 bg-lightGray" />}
          </React.Fragment>
        );
      })}
    </div>
  );
};

export default ACCreationSteps;
